import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        // Buscar uma página de ocorrências
        fetchOccurrences(ctx, queryParams) {
            const {
                assetId,
                startDate = '',
                endDate = '',
                page = 1,
                perPage = 100

            } = queryParams;

            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/SafeSpot/searchoccurrences`, {
                        params: {
                            assetId,
                            start: startDate,
                            end: endDate,
                            page,
                            perPage
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchIsSafeSpot(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/SafeSpot/issafespot`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        // Buscar todas as páginas de ocorrências recursivamente
        fetchAllOccurrences(ctx, {
            assetId,
            startDate,
            endDate,
            page = 1,
            allData = []
        }) {
            return new Promise((resolve, reject) => {
                ctx.dispatch('fetchOccurrences', {
                        assetId,
                        startDate,
                        endDate,
                        page,
                        perPage: 100
                    })
                    .then(response => {
                        const newData = response.data.data || [];
                        const combinedData = allData.concat(newData);

                        // Se retornou dados, busca próxima página
                        if (newData.length > 0 && newData.length === 100) {
                            ctx.dispatch('fetchAllOccurrences', {
                                    assetId,
                                    startDate,
                                    endDate,
                                    page: page + 1,
                                    allData: combinedData
                                })
                                .then(resolve)
                                .catch(reject);
                        } else {
                            // Retorna todos os dados acumulados
                            resolve({
                                data: combinedData
                            });
                        }
                    })
                    .catch(reject);
            });
        },

        exportOccurrencesToExcel(ctx, {
            assetId,
            startDate,
            endDate,
            page = 1,
            perPage = 100
        }) {
            return new Promise((resolve, reject) => {
                // Construir query params de forma segura, removendo valores undefined/null
                const params = new URLSearchParams()

                if (assetId) {
                    params.append('AssetId', assetId)
                }
                if (startDate) {
                    params.append('Start', startDate)
                }
                if (endDate) {
                    params.append('End', endDate)
                }
                params.append('page', page)
                params.append('perPage', perPage)

                axios({
                        url: `/api/v1/SafeSpot/ExportOccurrencesExcel?${params.toString()}`,
                        method: 'GET',
                        responseType: 'blob', // important
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        exportOccurrencesToKML(ctx, {
            assetId,
            startDate,
            endDate,
            page = 1,
            perPage = 100
        }) {
            return new Promise((resolve, reject) => {
                const params = new URLSearchParams()

                if (assetId) {
                    params.append('AssetId', assetId)
                }
                if (startDate) {
                    params.append('Start', startDate)
                }
                if (endDate) {
                    params.append('End', endDate)
                }
                params.append('page', page)
                params.append('perPage', perPage)

                axios({
                    url: `/api/v1/SafeSpot/ExportOccurrencesKML?${params.toString()}`,
                    method: 'GET',
                    responseType: 'blob', 
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
